/* eslint-disable */

import MapWrapper from '../map/MapWrapper.vue'
import {mapActions, mapMutations} from 'vuex'
import * as mi from '../../modules/map/interface.js'
import * as uuidv1 from 'uuid/v1'
import {ordinal} from '../../modules/utils.js'
import {BTabs, BTab, BOverlay} from 'bootstrap-vue'

//import axios from 'axios'

// A reference to this component.
let component

const wikiUrls = {
    18: "A18_road_(England)",
    42: "A42_road_(England)",
    47: "A47_road",
    50: "A50_road",
    69: "A69_road"
}

const land = {
    w: 2165,
    h: 1530
}

const dims = land

function transferCanvasToImg(canvas, imgId) {
    let img = new Image()
    img.src = canvas.toDataURL()
    document.getElementById(imgId).src = img.src
}

function getCanvases() {
    let canvases = document.getElementById(component.mapId).querySelectorAll("canvas")
    let map = canvases[0]
    let road = canvases[1]
    let card = document.getElementById('card-canvas')
    let working = document.getElementById('working-canvas')
    return {
        map, road, card, working
    }
}

function drawFrontOuter() {
    console.log("->drawFrontOuter")
    let canvases = getCanvases()
    let ctx = canvases.working.getContext("2d")
    ctx.fillStyle = "#FFFFFF"
    ctx.fillRect(0, 0, dims.w, dims.h)
    ctx.drawImage(canvases.road, 0 , 0, dims.w, dims.h)
    transferCanvasToImg(canvases.working, "front-outer")
}

function drawFrontInner() {
    console.log("->drawFrontInner")
    let canvases = getCanvases()
    let ctx = canvases.working.getContext("2d")
    ctx.fillStyle = "#FFFFFF"
    ctx.fillRect(0, 0, dims.w, dims.h)
    ctx.drawImage(canvases.map, 0, 0, dims.w, dims.h)
    ctx.drawImage(canvases.road, 0, 0, dims.w, dims.h)
    transferCanvasToImg(canvases.map, "front-inner-map")
    transferCanvasToImg(canvases.road, "front-inner-road")
}

function doDrawCard() {
    console.log("->doDrawCard")

    const card = {
        w: dims.h * 4,
        h: dims.w
    }
    const qw = card.w / 4
    const bleed = 90

    // Prep the card canvas
    let canvases = getCanvases()
    let ctx = canvases.card.getContext("2d")
    ctx.fillStyle = "#FFFFFF"
    ctx.fillRect(0, 0, card.w, card.h)
    ctx.save()

    // Translate the context to its center for rotation
    ctx.translate(card.w / 2, card.h / 2)

    // Rotate for the maps
    ctx.rotate(-Math.PI / 2)

    if (component.numberChanged) {
        drawFrontOuter()
        ctx.drawImage(canvases.working, -card.h / 2, -qw, card.h, qw)
        drawFrontInner()
        ctx.drawImage(canvases.working, -card.h / 2, 0, card.h, qw)
    }

    component.numberChanged = false
    component.working = false
    return





    



    // Draw the inside front - road and map


    // Draw the front - just the cryptic red swoosh
    ctx.drawImage(roadCanvas, -h / 2, -qw, h, qw)
    transferCanvasToImg(roadCanvas, 'front')

    // Rotate for outer rear
    ctx.rotate(Math.PI)

    // Outer rear
    ctx.fillStyle = "#000000" // Font color
    ctx.strokeStyle = "#000000" // Line color
    ctx.lineWidth = 2
    const lh = 50 // Line height

    const line1 = "A-Road Cards by https://aroads.appspot.com"
    ctx.font = "50px Avenir"
    let m = ctx.measureText(line1)
    ctx.fillText(line1, -m.width/2, (w / 2) - bleed - 3*lh)

    // A border above the text
    ctx.beginPath()
    ctx.moveTo(-m.width/1.5, (w/2) - bleed - 4*lh - 15)
    ctx.lineTo(m.width/1.5, (w/2) - bleed - 4*lh - 15)
    ctx.stroke()

    const line2 = "Map data © Mapbox https://www.mapbox.com/about/maps/ © OpenStreetMap http://www.openstreetmap.org/copyright"
    ctx.font = "28px Avenir"
    m = ctx.measureText(line2)
    ctx.fillText(line2, -m.width/2, (w / 2) - bleed - 2*lh)

    const line3 = "A-Road information from https://en.wikipedia.org/" + wikiUrls[component.number] + " CC BY-SA"
    ctx.font = "28px Avenir"
    m = ctx.measureText(line3)
    ctx.fillText(line3, -m.width/2, (w / 2) - lh - bleed)

    const line4 = "CC BY-SA: https://creativecommons.org/licenses/by-sa/3.0/"
    ctx.font = "30px Avenir"
    m = ctx.measureText(line4)
    ctx.fillText(line4, -m.width/2, (w / 2)- bleed)

    // Rotate for inner rear
    ctx.rotate(Math.PI)

    // Inner rear
    const happy = "Happy A" + ordinal(component.number) + " Birthday!"
    ctx.font = "100px Avenir"
    let mHappy = ctx.measureText(happy)
    ctx.fillText(happy, -mHappy.width/2, qw + qw/3)

    const greeting = component.greeting
    ctx.font = "80px Avenir"
    m = ctx.measureText(greeting)
    ctx.fillText(greeting, -h/2 + bleed*2, qw + bleed*2)

    const signoff = component.signoff
    ctx.font = "80px Avenir"
    m = ctx.measureText(signoff)
    ctx.fillText(signoff, h/2 - bleed*2 - m.width, 2 * qw - bleed*2)

    let drawP
    if (wikiUrls[component.number]) {
        //let introP = axios.post("/api/road/wiki", {
        //    title: wikiUrls[component.number]
        //})
        //drawP = introP.then(function() {
            //const roadInfo = response.data.result
            const roadInfo = "The A47 is a trunk road in England linking Birmingham to Lowestoft, Suffolk. Most of the section between Birmingham and Nuneaton is now classified as the B4114."
            if (roadInfo) {
                wrapText(ctx, roadInfo, -mHappy.width/2, qw + qw/3 + 80, mHappy.width, 30, 'Avenir')
            }
            //return true
            drawP = Promise.resolve()
        //})
    }
    else {
        drawP = Promise.resolve()
    }

    drawP.then(function() {
        window.setTimeout(function() {
            ctx.restore()
            numberChanged = false
        }, 1000)
    })
}

function wrapText(context, text, x, y, maxWidth, fontSize, fontFace){
    let words = text.split(' ')
    let line = ''
    let lineHeight = fontSize + 5
    context.font = fontSize + "px " + fontFace

    for(var n = 0; n < words.length; n++) {
        var testLine = line + words[n] + ' '
        var metrics = context.measureText(testLine)
        var testWidth = metrics.width
        if(testWidth > maxWidth) {
            context.fillText(line, x, y)
            line = words[n] + ' '
            y += lineHeight
        }
        else {
            line = testLine
        }
    }
    context.fillText(line, x, y)
    return(y)
}

let resolveLater

export default {
    components: {
        MapWrapper,
        BTabs,
        BTab,
        BOverlay
    },
    data: function() {
        return {
            greeting: "",
            signoff: "",
            haveMap: false,
            mapId: "",
            number: 47,
            working: false,
            launched: false,
            numberChanged: true,
        }
    },
    computed: {
        frontOuterId() {
            return 'frontOuter' + this.id
        } 
    },
    methods: {
        mapLoaded(id) {
            console.log("->component.mapLoaded")
            this.mapId = id
            if (typeof resolveLater == "function") resolveLater()
        },
        drawCard() {
            console.log("->component.drawCard")
            this.working = true
            this.launched = true
            let loadP = new Promise(function(resolve) {
                resolveLater = resolve
            })

            if (this.numberChanged) {
                this.renderRoad().then(() => {
                    loadP.then(() => {
                        window.setTimeout(() => {
                            doDrawCard()
                        }, 1000)
                    })
                })
            }
            else doDrawCard()
        },
        renderRoad() {
            console.log("->component.renderRoad")
            mi.clearRoads()
            return this.getRoad({number: this.number}).then((road) => {
                if (!road) return false
                else if (!road.found) return false
                else {
                    mi.processRoad(road.geojson, road.number)
                    return true
                }
            })
        },
        ...mapActions('roads', ['getRoad']),
        ...mapMutations('map', ['setActiveSource'])
    },
    watch: {
        number() {
            this.numberChanged = true
        }
    },
    mounted() {
        component = this
        let working = document.getElementById('working-canvas')
        transferCanvasToImg(working, "front-outer")
    },
    created() {
        this.setActiveSource('aroads')
    }
}